import { useState, useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useMediaQuery } from 'react-responsive';
import { BadgeVariant } from 'root/widgets/verified-badge/types';
import { SCREEN_BREAKPOINTS } from 'root/widgets/constants';

const TOOLTIP_KEY = {
  [BadgeVariant.AGENT]: 'isAgentTooltipViewed',
  [BadgeVariant.LISTING]: 'isListingTooltipViewed',
};

export const useTooltip = (variant: BadgeVariant) => {
  const [isTooltipViewed, setIsTooltipViewed] = useLocalStorage<boolean | null>(TOOLTIP_KEY[variant], null);
  const [isBadgeOverlayVisible, setIsBadgeOverlayVisible] = useState(false);
  const [isInfoTooltipVisible, setIsInfoTooltipVisible] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: SCREEN_BREAKPOINTS.SM });

  useEffect(() => {
    if (!isTooltipViewed) {
      setIsBadgeOverlayVisible(true);
      setIsInfoTooltipVisible(true);
    }
  }, [isTooltipViewed]);

  const handleBadgeOverlayToggle = (show: boolean): void => {
    setIsBadgeOverlayVisible(show);
  };

  const handleBadgeOverlayClose = (): void => {
    setIsTooltipViewed(true);
    handleBadgeOverlayToggle(false);
  };

  const handleInfoTooltipClose = (): void => {
    setIsInfoTooltipVisible(false);
    setIsTooltipViewed(true);
  };

  const handleMouseOver = (): void => {
    if (isMobile) {
      return;
    }

    if (!isBadgeOverlayVisible) {
      handleBadgeOverlayToggle(true);
    }
  };

  return {
    isTooltipViewed,
    isBadgeOverlayVisible,
    isInfoTooltipVisible,
    handleBadgeOverlayToggle,
    handleBadgeOverlayClose,
    handleInfoTooltipClose,
    handleMouseOver,
  };
};
